import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

const SideloadCell = memo(({ sideloadNeeded }) => {
  return (
    sideloadNeeded && (
      <div>
        <Icon glyph="extras-sideload" size="3.2rem" color="grey500" />
      </div>
    )
  );
});

SideloadCell.propTypes = {
  sideloadNeeded: PropTypes.bool,
};

export default SideloadCell;
